module.exports = __webpack_public_path__ + "img/expand.368aa1f2.svg";